import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./locales/i18n";
import { initDemo } from "./demo";

export const DEMO_HOSTNAME = "demo.test.wrapsodyeco.com";

async function bootstrap() {
  if (
    window.location.hostname === DEMO_HOSTNAME ||
    window.eco.serviceType === "DEMO"
  ) {
    await initDemo();
  }
  ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
}
bootstrap();
